module.exports = __webpack_public_path__ + "static/media/filterSelected.87745775.svg";